
/* injects from baggage-loader */

'use strict';

export default class AccountHomeController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		// this.$log.log(this.investments);
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/home/account.home.controller.js